import { Container } from '@mui/material'
import { tokens } from '../../../theme'

export function MobileLayout({ children }) {
  return (
    <Container
      maxWidth="md"
      disableGutters
      sx={{
        minHeight: '100vh',
        bgcolor: tokens.colors.background,
      }}
    >
      {children}
    </Container>
  )
}
